import React from 'react';
import { Box, Button } from '@chakra-ui/react';

const Pagination = ({ page, setPage, limit, total }) => {
  const totalPages = Math.ceil(total / limit);

  return (
    <Box mt={4}>
      <Button onClick={() => setPage(page => Math.max(page - 1, 1))} disabled={page === 1}>
        Previous
      </Button>
      <Button ml={2} onClick={() => setPage(page + 1)} disabled={page === totalPages}>
        Next
      </Button>
    </Box>
  );
};

export default Pagination;
